module.exports = __webpack_public_path__ + "img/hydrogen-energy-fuel.df454b17.png";